var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import PlayableLauncher from "../../components/playable-launcher";
import { filterExtraParamsForLauncher, getItemFromLocalStorage, isIosOrAndroid, contentTypeCategories, sendErrorToSentry } from "../../utils/web-helper";
import { setActiveCourse, setMyToDoInitialData } from "../../components/freemium/utilityFunctions";
var handleClick = function (actionData, actionParams, payloadData, eventParams) {
    if (eventParams === void 0) { eventParams = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var contentType, fetchCurrentCourseCode, playableData, activeTabCode;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            if (payloadData && contentTypeCategories.includes(payloadData.eventCategory)) {
                contentType = payloadData === null || payloadData === void 0 ? void 0 : payloadData.eventCategory;
            }
            if (contentType == null) {
                contentType = ((_b = (_a = payloadData === null || payloadData === void 0 ? void 0 : payloadData.elementAction) === null || _a === void 0 ? void 0 : _a.metaDataStore) === null || _b === void 0 ? void 0 : _b.entity_type) == "GameLevelCluster" ? "Game" : "Worksheet";
            }
            fetchCurrentCourseCode = function () {
                if (actionParams === null || actionParams === void 0 ? void 0 : actionParams.courses) {
                    for (var _i = 0, _a = actionParams.courses; _i < _a.length; _i++) {
                        var course = _a[_i];
                        if (course.subject_code === actionData.subject_name) {
                            return course.code;
                        }
                    }
                }
            };
            playableData = {
                noOfFreePlayableLeft: -1
            };
            activeTabCode = getItemFromLocalStorage("flutter.activeTabCode");
            if (window.location.hash.includes("#/todo_list") || ((_e = (_d = (_c = payloadData === null || payloadData === void 0 ? void 0 : payloadData.elementAction) === null || _c === void 0 ? void 0 : _c.metaDataStore) === null || _d === void 0 ? void 0 : _d.hash) === null || _e === void 0 ? void 0 : _e.includes("#/todo_list"))) {
                activeTabCode = null;
            }
            if (actionData.category === 'aquarium_jungle') {
                PlayableLauncher({ entity_type: 'FunGame', game_type: actionData.game_code, active_tab_code: activeTabCode, extra_param_for_launcher: filterExtraParamsForLauncher(actionData) }, undefined, actionParams.closeGameHandler);
            }
            else {
                PlayableLauncher(__assign(__assign({ entity_type: actionData.entity_type, content_type: contentType, game: actionData.game_name, learning_objective_id: actionData === null || actionData === void 0 ? void 0 : actionData.learning_objective_id, playable_id: actionData === null || actionData === void 0 ? void 0 : actionData.playable_id, user_lo_task_id: actionData === null || actionData === void 0 ? void 0 : actionData.user_lo_task_id, active_tab_code: activeTabCode, free_cards_count: playableData.noOfFreePlayableLeft, current_course_code: fetchCurrentCourseCode(), extra_param_for_launcher: filterExtraParamsForLauncher(actionData), from_flutter: true }, eventParams), { 
                    // subject: actionData?.event_properties?.subject,
                    event_properties: actionData === null || actionData === void 0 ? void 0 : actionData.event_properties }), (actionData === null || actionData === void 0 ? void 0 : actionData.click_source) || 'content_group', actionParams.closeGameHandler);
            }
            return [2 /*return*/];
        });
    });
};
export var playableLauncher = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1, data;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 6, , 7]);
                return [4 /*yield*/, setActiveCourse(props, false)];
            case 1:
                _g.sent();
                setMyToDoInitialData(props);
                if (!window.__BROWSER_NOT_SUPPORTED__) return [3 /*break*/, 2];
                (_b = (_a = props.actionParams) === null || _a === void 0 ? void 0 : _a.setShowGamesUnsupportedScreen) === null || _b === void 0 ? void 0 : _b.call(_a, true);
                // @ts-ignore
                window.__BROWSER_NOT_SUPPORTED__ = false;
                return [3 /*break*/, 5];
            case 2:
                if (!(((_c = props === null || props === void 0 ? void 0 : props.actionData) === null || _c === void 0 ? void 0 : _c.game_engine) === 'unity' && isIosOrAndroid())) return [3 /*break*/, 3];
                (_e = (_d = props.actionParams) === null || _d === void 0 ? void 0 : _d.setShowGamesUnsupportedScreen) === null || _e === void 0 ? void 0 : _e.call(_d, true);
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, handleClick(props.actionData, props.actionParams, props.payloadData, props.eventParams)];
            case 4:
                _g.sent();
                _g.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                error_1 = _g.sent();
                data = {
                    'methodName': 'playableLauncher',
                    'from': window.location.pathname,
                    'hash': window.location.hash,
                    'click_source': (_f = props.actionData) === null || _f === void 0 ? void 0 : _f.click_source,
                    'error': error_1 === null || error_1 === void 0 ? void 0 : error_1.message,
                    'stack': error_1 === null || error_1 === void 0 ? void 0 : error_1.stack,
                };
                // @ts-ignore global function
                trackAnalyticsEvent('Error Occured!', data);
                sendErrorToSentry(new Error("PlayableLauncher failed"), data);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); };
